/**
 * Typ encji
 *
 * @export
 * @enum {number}
 */
export enum EntityType {
  /**
   * Dokument
   */
  DOCUMENT = 'document',

  /**
   * Moduł
   */
  MODULE = 'module',

  /**
   * Procedura
   */
  PROCEDURE = 'procedure',

  /**
   * Ustawienie
   */
  SETTING = 'setting',

  /**
   * Schema
   */
  SCHEMA = 'schema',

  /**
   * Etap
   */
  STAGE = 'stage',

  /**
   * Status
   */
  STATUS = 'status',

  /**
   * Węzeł struktury (szkoła)
   */
  STRUCTURE_NODE = 'structure_node'
}
